import { Roles } from '../enums/roles';

/**
 * Set of all valid Roles enum values, used for matching
 * Entra app role values to application roles.
 */
const ROLES_VALUES = new Set<string>(Object.values(Roles));

/**
 * Checks whether a value matches a known Roles enum value.
 * Used to validate Entra app role values against the application's role definitions.
 */
export function isValidRoleValue(value: string): value is Roles {
    return ROLES_VALUES.has(value);
}
